function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-61.038 -54.047)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-86.599 -45.677)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-170.207 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-221.865 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-273.975 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-353.984 -13.098)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__g"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-421.934 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-473.593 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__i"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-503.742 -50.356)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__j"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-593.651 -13.729)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__k"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-633.97 -43.697)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__l"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__m"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-671.501 -32.807)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__n"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-746.83 -43.697)"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "GW-20-50-PDP_svg__o"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 86h835V0H0z",
  transform: "translate(-817.478 -31.008)"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-2.52l-.629 1.979c-2.88 8.46-4.5 11.97-6.3 14.041-1.62 1.798-4.231 2.789-7.651 2.789-11.879 0-17.008-9.45-17.008-31.409 0-11.339 1.889-18.99 5.759-22.859 2.34-2.43 6.3-3.96 9.99-3.96 6.839 0 10.08 3.33 10.08 10.62v12.238h-9.72v2.071H5.399v-2.071H.72v-20.248l-1.53-.72c-6.66-2.97-10.71-3.959-16.649-3.959-16.56 0-27.359 11.609-27.359 29.698 0 19.979 11.069 32.669 28.439 32.669 5.31 0 9.989-1.08 16.379-3.69z",
  transform: "matrix(.43238 0 0 -.43238 20.176 8.748)",
  clipPath: "url(#GW-20-50-PDP_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h4.229c10.08 0 15.12 4.5 15.12 13.229 0 3.061-.63 5.76-2.07 8.01-2.16 3.6-4.77 4.68-10.889 4.68H0zm21.688-31.948L0-.72v-29.159h6.39v-2.069h-20.789v2.069H-9v55.798h-5.399v2.16H8.279c7.829 0 11.789-.99 15.48-4.051 3.51-2.699 5.399-6.478 5.399-10.619 0-8.189-7.739-14.669-17.729-14.669-.27 0-.54 0-.99.09l20.339-28.709h4.59v-2.069z",
  transform: "matrix(.43238 0 0 -.43238 31.228 12.367)",
  clipPath: "url(#GW-20-50-PDP_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-43.559v2.069h5.4v55.798h-5.4v2.16H-.721V40.588H-2.88l-.36 1.439c-2.88 10.8-3.96 13.411-5.85 14.67-1.53.991-2.97 1.17-8.28 1.17h-11.789V31.948h5.22c5.49 0 6.299.9 8.819 10.35 0 .27.181.63.27 1.17h2.161V18.269h-2.161c-2.79 10.71-3.42 11.519-8.819 11.519h-5.49V2.069h14.22c4.769 0 6.839 1.531 8.639 6.21 1.62 4.14 2.88 8.549 3.96 13.77H0z",
  transform: "matrix(.43238 0 0 -.43238 67.379 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-43.558v2.069h5.4v55.798h-5.4v2.16H-.72V40.588h-2.16l-.359 1.439c-2.88 10.8-3.96 13.411-5.851 14.67-1.529.991-2.97 1.17-8.279 1.17h-11.789V31.948h5.22c5.489 0 6.299.9 8.819 10.35 0 .27.18.63.269 1.17h2.161V18.269h-2.161c-2.789 10.71-3.42 11.519-8.819 11.519h-5.489V2.069H-14.939c4.769 0 6.839 1.531 8.639 6.21 1.62 4.14 2.88 8.549 3.96 13.77H0z",
  transform: "matrix(.43238 0 0 -.43238 89.715 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-3.06l-33.479 56.607V2.069h7.2V0h-14.939v2.069h5.399v55.798h-5.399v2.16h16.109L-2.43 16.648v41.219h-7.2v2.16H5.399v-2.16H0z",
  transform: "matrix(.43238 0 0 -.43238 112.246 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-3.601L-13.95 40.318-24.84 0h-3.959l-15.03 58.498h-3.959v2.16h18.989v-2.16h-5.85l11.16-44.098 8.189 30.688-3.42 13.41h-5.399v2.16H-2.79v-2.16h-6.75L1.17 14.4l11.789 44.098H6.93v2.16h12.508v-2.16h-3.869z",
  transform: "matrix(.43238 0 0 -.43238 146.84 26.453)",
  clipPath: "url(#GW-20-50-PDP_svg__f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-43.559v2.069h5.4v55.798h-5.4v2.16H-.721V40.588H-2.88l-.36 1.439c-2.88 10.8-3.96 13.411-5.85 14.67-1.53.991-2.97 1.17-8.28 1.17h-11.789V31.948h5.22c5.49 0 6.299.9 8.819 10.35 0 .27.181.63.27 1.17h2.161V18.269h-2.161c-2.79 10.71-3.42 11.519-8.819 11.519h-5.49V2.069h14.22c4.769 0 6.839 1.531 8.639 6.21 1.62 4.14 2.88 8.549 3.96 13.77H0z",
  transform: "matrix(.43238 0 0 -.43238 176.22 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-43.559v2.069h5.4v55.798h-5.4v2.16H-.721V40.588H-2.88l-.36 1.439c-2.88 10.8-3.96 13.411-5.85 14.67-1.53.991-2.97 1.17-8.28 1.17h-11.789V31.948h5.22c5.49 0 6.299.9 8.819 10.35 0 .27.181.63.27 1.17h2.161V18.269h-2.161c-2.79 10.71-3.42 11.519-8.819 11.519h-5.49V2.069h14.22c4.769 0 6.839 1.531 8.639 6.21 1.62 4.14 2.88 8.549 3.96 13.77H0z",
  transform: "matrix(.43238 0 0 -.43238 198.557 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0l23.399-34.559h3.51v-2.069H14.67L-6.749-4.499 14.67 21.239H8.64v2.16h15.12v-2.16h-5.941zm-16.649-34.559v55.798h-5.4v2.16H-1.62v-2.16h-6.029v-55.798h6.029v-2.069h-20.429v2.069z",
  transform: "matrix(.43238 0 0 -.43238 211.593 10.343)",
  clipPath: "url(#GW-20-50-PDP_svg__i)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-36.898v7.829l1.799 1.62c5.13 4.5 10.17 9.449 14.4 13.86a74.949 74.949 0 016.21 7.379c3.689 4.951 5.67 10.62 5.67 15.839 0 7.92-4.05 12.6-10.71 12.6-3.33 0-5.13-.811-6.3-2.609-1.17-1.891-3.779-8.46-5.76-14.22l-.809-2.25h-2.34l.719 18.72c5.22 1.709 9.36 2.429 13.68 2.429C-7.47 61.197.63 54.987.63 44.998c0-5.58-2.699-11.34-7.919-16.65-3.96-4.049-10.35-9.36-16.74-14.039l-7.829-5.85-1.531-1.17c2.521.45 3.42.54 5.401.54H-2.34v6.75H0z",
  transform: "matrix(.43238 0 0 -.43238 250.468 26.18)",
  clipPath: "url(#GW-20-50-PDP_svg__j)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v1.35c0 18.539-3.42 27.808-10.35 27.808-6.929 0-10.349-9.269-10.349-27.719 0-21.239 3.15-30.508 10.349-30.508C-3.329-29.069-.18-20.25 0 0m9.54 1.35V-.09c0-18.81-7.83-31.049-19.89-31.049-11.968 0-19.798 12.239-19.798 30.958 0 19.169 7.739 31.41 19.798 31.41 11.79 0 19.44-11.52 19.89-29.879",
  transform: "matrix(.43238 0 0 -.43238 267.901 13.223)",
  clipPath: "url(#GW-20-50-PDP_svg__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665.381 33.258h-17.999v5.939h17.999z",
  transform: "matrix(.43238 0 0 -.43238 -6.215 32.117)",
  clipPath: "url(#GW-20-50-PDP_svg__l)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h2.431C4.141-6.389 6.66-12.959 8.28-15.209c1.35-1.89 4.05-2.97 7.38-2.97 5.039 0 8.819 2.521 10.079 6.57.81 2.97 1.35 7.11 1.35 12.06 0 7.739-1.35 12.419-4.319 15.029-1.89 1.709-4.951 2.79-8.01 2.79-5.58 0-9.72-3.06-11.52-8.639H.63v31.318h32.489v-7.83H3.24V14.76c3.781 4.41 7.47 6.12 13.05 6.12 11.699 0 20.249-8.46 20.249-19.98 0-12.149-9-21.148-21.149-21.148-5.13 0-10.98 1.709-15.39 4.5z",
  transform: "matrix(.43238 0 0 -.43238 284.129 17.932)",
  clipPath: "url(#GW-20-50-PDP_svg__m)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v1.35c0 18.539-3.42 27.808-10.35 27.808-6.929 0-10.349-9.269-10.349-27.719 0-21.239 3.15-30.508 10.349-30.508C-3.329-29.069-.18-20.25 0 0m9.54 1.35V-.09c0-18.81-7.83-31.049-19.89-31.049-11.968 0-19.798 12.239-19.798 30.958 0 19.169 7.739 31.41 19.798 31.41 11.79 0 19.44-11.52 19.89-29.879",
  transform: "matrix(.43238 0 0 -.43238 316.7 13.223)",
  clipPath: "url(#GW-20-50-PDP_svg__n)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-.27 12.329-1.62 15.658-6.659 15.658-5.22 0-6.75-4.049-6.75-18.268 0-10.35 1.71-13.86 6.75-13.86 5.039 0 6.75 3.51 6.75 13.679C.091-1.891.091-.9 0 0m6.57-.451c0-10.529-5.49-17.998-13.229-17.998-7.83 0-13.32 7.469-13.32 18.089 0 10.529 5.49 17.999 13.32 17.999 7.739 0 13.229-7.47 13.229-18.09m-44.008-16.828h-2.61l30.059 60.027h2.79zm3.599 43.557c-.269 12.24-1.619 15.57-6.659 15.57-5.22 0-6.75-4.05-6.75-18.18 0-10.439 1.71-13.859 6.75-13.859s6.75 3.509 6.75 13.589c0 .991 0 1.891-.091 2.88m6.57-.45c0-10.529-5.49-18.089-13.229-18.089-7.83 0-13.319 7.56-13.319 18.089s5.489 18.09 13.319 18.09c7.739 0 13.229-7.561 13.229-18.09",
  transform: "matrix(.43238 0 0 -.43238 347.246 18.71)",
  clipPath: "url(#GW-20-50-PDP_svg__o)"
}));

function SvgGw2050Pdp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318.968,
    height: 28.012,
    viewBox: "0 0 350.865 28.012",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgGw2050Pdp;